import { render, staticRenderFns } from "./weChatList.vue?vue&type=template&id=7c55a1f4&scoped=true"
import script from "./weChatList.vue?vue&type=script&lang=js"
export * from "./weChatList.vue?vue&type=script&lang=js"
import style0 from "./weChatList.vue?vue&type=style&index=0&id=7c55a1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c55a1f4",
  null
  
)

export default component.exports